module.exports = __webpack_public_path__ + "static/media/stairoids.8dbc8e24.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/stairoids.webp
// module id = 901
// module chunks = 0